(() => {
  const chosenForms = new Set();
  let observedForm, stickyObserver;
  function refreshStickyObserver() {
    const sticky=document.querySelector('.astroclaro-pdp .product-quick-add') || document.querySelector('.product-quick-add');
    const form=sticky && document.getElementById(sticky.getAttribute('form'));
    const footer=document.querySelector('.footer');
    if(!sticky || !form || !footer) return;
    const update=()=>sticky.classList.toggle('is-visible', form.getBoundingClientRect().bottom<0 && footer.getBoundingClientRect().top>innerHeight);
    update();
    if(form===observedForm) return;
    stickyObserver?.disconnect(); observedForm=form;
    stickyObserver=new IntersectionObserver(update);
    stickyObserver.observe(form);stickyObserver.observe(footer);update();
  }
  function formId() { return document.querySelector('.astroclaro-pdp variant-picker')?.getAttribute('form-id'); }
  document.addEventListener('click', event => {
    if (!event.isTrusted) return;
    const target = event.target;
    const sticky = target.closest('.product-quick-add');
    const id = formId();
    if (sticky && target.closest('button[type="submit"]') && id && !chosenForms.has(id)) {
      event.preventDefault(); event.stopImmediatePropagation();
      const picker = document.querySelector('.astroclaro-pdp variant-picker');
      picker?.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      const focus = picker?.querySelector('input:checked + label, button, select');
      if (focus?.matches('label')) document.getElementById(focus.htmlFor)?.focus({preventScroll:true});
      else focus?.focus({preventScroll:true});
      return;
    }
    const appChoice = target.closest('.astroclaro-pdp .swatch-view-item');
    if (appChoice && id) chosenForms.add(id);
    const picker = target.closest('.astroclaro-pdp variant-picker');
    if (picker && target.closest('label,input[data-option-position],.popover-listbox__option')) chosenForms.add(picker.getAttribute('form-id'));
  }, true);
  document.addEventListener('change', event => {
    if (!event.isTrusted) return;
    const picker = event.target.closest('.astroclaro-pdp variant-picker');
    if (picker && event.target.matches('input[data-option-position],select')) chosenForms.add(picker.getAttribute('form-id'));
  }, true);
  function fitOptionGrids(){
    document.querySelectorAll('.astroclaro-pdp .bv5-native-option-values:not(.bv5-color-circles)').forEach(grid=>{
      if(grid.hasAttribute('data-bv5-three-base'))grid.classList.remove('bv5-native-option-values--two');
      const labels=[...grid.querySelectorAll('label,a.bv5-native-option')];
      const overflow=labels.some(l=>l.scrollWidth>l.clientWidth+1);
      if(overflow&&!grid.classList.contains('bv5-native-option-values--two'))grid.classList.add('bv5-native-option-values--two');
    });
  }
  document.addEventListener('change',event=>{
    const input=event.target;
    if(!input.matches('input[data-bv5-option-value]')||!input.closest('.astroclaro-pdp variant-picker[data-astro-native-options]'))return;
    const label=input.closest('fieldset')?.querySelector('.variant-picker__option-info .h-stack>span');
    if(label)label.textContent=input.dataset.bv5DisplayValue||input.dataset.bv5OptionValue;
  },true);
  function moveAdvice() {
    const light = document.querySelector('.astroclaro-pdp [data-bv5-native-light]');
    const position = light?.getAttribute('data-bv5-option-position');
    document.querySelectorAll('.astroclaro-pdp .swatch-single').forEach(group => {
      const isLight = !!position && !!group.querySelector(`[swatch-option="option${position}"]`);
      group.toggleAttribute('data-v68a-light-app', isLight);
    });

  }
  const run = () => {moveAdvice();fitOptionGrids();refreshStickyObserver();};
  document.fonts?.ready.then(fitOptionGrids);
  let scrollPending=false;
  const onScroll=()=>{if(scrollPending)return;scrollPending=true;requestAnimationFrame(()=>{scrollPending=false;refreshStickyObserver();});};
  document.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',onScroll,{passive:true});
  const observe = () => {
    const area = document.querySelector('main');
    if (area) new MutationObserver(run).observe(area,{childList:true,subtree:true});
  };
  document.addEventListener('keydown',event=>{
    if(event.isTrusted && ['Enter',' ','ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].includes(event.key) && event.target.closest('.astroclaro-pdp .swatch-view-item')){
      const id=formId(); if(id) chosenForms.add(id);
    }
  },true);
  document.addEventListener('product:rerender',()=>queueMicrotask(run));
  document.addEventListener('shopify:section:load',run);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>{run();observe();},{once:true}); else {run();observe();}
})();